module.exports = __webpack_public_path__ + "img/skull_9.daf60bf0.png";